import { useEffect } from "react";

export const useInitKCP = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_KCP_PAYMENT_MODULE_URL || "";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
};
